import styled from "styled-components";
import { HXPage, HXPageHeader } from "../HXDesktopPage";
import { FlexColumn, FlexRow } from "../common.styles";
import { HXSectionTitle, Text, Subtitle } from "../HXDesktopPage.styles";
import { colors } from "healthex-common/colors";
import PeopleAltOutlined from "@mui/icons-material/PeopleAltOutlined";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import { FormItemDiv, FormSection } from "../AddProjectJoinCommon/AddJoinCommonComponents.styles";
import { FileUploadView } from "../FileUploadView";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import CircularProgress from "@mui/material/CircularProgress";
export const AddPatientsParent = styled(HXPage) `
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
export const AddPatientsPageHeader = styled(HXPageHeader) ``;
export const AddPatientsFooterContainer = styled(FlexRow) `
    gap: 8px;
    justify-content: flex-end;
`;
export const AddPatientDetailsContainer = styled(FlexColumn) `
    gap: 16px;
`;
export const AddPatientDetailsTitle = styled(Subtitle) ``;
export const AddPatientFileFormContainer = styled(FlexColumn) `
    gap: 16px;
    align-items: flex-start;
`;
export const AddPatientDetailsForm = styled(FlexColumn) `
    gap: 24px;
    align-items: stretch;
    width: 800px;
    background-color: ${colors.white_main};
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    padding: 24px;

    /* Ensure all FlexRow children stretch to full width */
    & > * {
        width: 100%;
    }

    /* Ensure FormSection children stretch properly */
    & .MuiFormControl-root,
    & .MuiTextField-root {
        width: 100%;
    }

    /* Align the last child (Add patient button) to the right */
    & > *:last-child {
        align-self: flex-end;
        width: auto;
    }
`;
export const EditPatientForm = styled(FlexColumn) `
    gap: 24px;
    align-items: flex-start;
    margin-top: 16px;
`;
export const PatientReviewContainer = styled(FlexColumn) `
    gap: 16px;
`;
export const PatientReviewTitle = styled(Subtitle) ``;
export const NoDataPlaceholder = styled(FlexColumn) `
    gap: 8px;
    align-items: center;
    justify-content: center;
    border: 1px solid ${colors.black_12};
    padding: 24px 80px;
    border-radius: 4px;
    align-self: stretch;
`;
export const PeopleAltOutlinedIcon = styled(PeopleAltOutlined) `
    height: 40px;
    width: 40px;
    color: ${colors.black_lighter};
`;
export const PlaceholderTitle = styled(HXSectionTitle) `
    color: ${colors.black_lighter};
`;
export const PlaceholderSubtitle = styled(Text) `
    color: ${colors.black_lighter};
`;
export const DeleteOutlinedIcon = styled(DeleteOutlined) `
    color: ${colors.tulip_main};
`;
export const FormSectionContainer = styled(FormSection) `
    flex: 1;
    width: 100%;
`;
export const FormItem = styled(FormItemDiv) `
    width: 100%;
`;
export const ContactInformation = styled(FlexColumn) `
    justify-content: center;
`;
export const AddPatientCSVUploadView = styled(FileUploadView) `
    width: 100%;
    min-height: 160px;
    border: 2px ${(props) => (props.requiredError ? "solid" : "dashed")};
    color: ${(props) => (props.disabled ? colors.black_30 : props.requiredError ? colors.tulip_main : colors.black_12)};
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const SuccessIcon = styled(CheckCircleOutline) `
    height: 24px;
    width: 24px;
    color: ${colors.forest_main};
`;
export const ErrorIcon = styled(WarningAmberOutlined) `
    height: 24px;
    width: 24px;
    color: ${colors.tulip_main};
`;
export const SuccessBannerList = styled.ul `
    margin: 0;
`;
export const SuccessBannerListItem = styled.li ``;
export const Spinner = styled(CircularProgress).attrs({ size: 14 }) ``;
export const ErrorText = styled.span `
    color: ${colors.tulip_main};
`;
export const AddJoinCommonSuccessBannerContainer = styled(FlexColumn) `
    padding: 4px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid ${colors.forest_main};
    background: ${colors.forest_8};
`;
